module.exports = __webpack_public_path__ + "img/ComunicacionEquipoEnByPass.cfdcaad9.svg";